import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
 } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth';
import { HttpError } from '../../domain';
import { AbstractAppConfig } from '../../../app.config';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  public static readonly GENERIC_ERROR_MSG = 'A network error occurred while making a request';
  private static readonly CONTENT_TYPE = 'Content-Type';
  private static readonly JSON = 'json';

  constructor(private appConfig: AbstractAppConfig, private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let httpError = new HttpError();
          if (this.isNetworkError(error)) {
            httpError = this.processNetworkError();
          } else if (error) {
            httpError = this.processBackendError(error);
          }

          if (this.doRedirect(error) && (httpError.status === 401 || httpError.status === 403)) {
            this.authService.signIn();
          }

          return throwError(httpError);
        })
      )
  }

  private isNetworkError(error) {
    return error && error.error instanceof ProgressEvent && error.error.type === 'error';
  }

  private processNetworkError(): HttpError {
    // A client-side or network error occurred. Handle it accordingly.
    let httpError = new HttpError();
    httpError.message = HttpErrorInterceptor.GENERIC_ERROR_MSG;
    httpError.status = null;
    console.error(HttpErrorInterceptor.GENERIC_ERROR_MSG);
    return httpError;
  }

  private processBackendError(error: HttpErrorResponse): HttpError {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    let httpError = new HttpError();
    if (error.headers
      && error.headers.get(HttpErrorInterceptor.CONTENT_TYPE)
      && error.headers.get(HttpErrorInterceptor.CONTENT_TYPE).indexOf(HttpErrorInterceptor.JSON) !== -1) {
      httpError = HttpError.from(error.error || {});
    }
    if (!httpError.status && error.status) {
      httpError.status = error.status;
    }
    console.error(`Backend returned code ${error.status}, body was: ${JSON.stringify(error.error)}`);
    return httpError;
  }

  private doRedirect(error: HttpErrorResponse) {
    if (error && error.url) {
      const activityUrl = this.appConfig.getActivityUrl();
      const postcodeUrl = this.appConfig.getPostcodeLookupUrl();

      if (activityUrl && activityUrl !== '' && error.url.startsWith(activityUrl)) {
        return false;
      }

      if (postcodeUrl && postcodeUrl !== '' && error.url.startsWith(postcodeUrl)) {
        return false;
      }
    }

    return true;
  }
 }
